export const LOCALES = {
  IT: "it-IT",
  EN: "en-US",
};
